import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { CommissionStore } from './commission.store';

@Injectable()
export class CommissionResolver implements Resolve<any> {

  constructor(
    private commissionStore: CommissionStore,
  ) { }

  resolve() {
    return this.commissionStore.loadPaymentRequestDetails();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/service/commission.resolver.ts